export const NO_USER_ERROR = 'NoUserError'
